import React, { createContext, useContext, ReactNode } from 'react';

interface BaseStepperContextValue {
  // Step navigation
  activeStep: number;
  setActiveStep: (step: number) => void;
  numOfSteps: () => number;
  handleNext: () => void;
  handleBack: () => void;
  handleReset: () => void;
  isLastStep: () => boolean;
  goToLastStep: () => void;

  // Save functionality
  handleSave: () => void;
  error: string | null;

  // Warning message functionality
  warningMessage: string;
  showWarning: boolean;

  // Step validation functionality
  updateStepValidation: (
    stepIndex: number,
    message: string,
    hasError: boolean
  ) => void;
}

const BaseStepperContext = createContext<BaseStepperContextValue | undefined>(
  undefined
);

export const useBaseStepperContext = (): BaseStepperContextValue => {
  const context = useContext(BaseStepperContext);
  if (!context) {
    throw new Error(
      'useBaseStepperContext must be used within a BaseStepperProvider'
    );
  }
  return context;
};

interface BaseStepperProviderProps {
  children: ReactNode;
  value: BaseStepperContextValue;
}

export const BaseStepperProvider: React.FC<BaseStepperProviderProps> = ({
  children,
  value,
}) => {
  return (
    <BaseStepperContext.Provider value={value}>
      {children}
    </BaseStepperContext.Provider>
  );
};

// Re-export the interface for other components to extend if needed
export type { BaseStepperContextValue };
